// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/**
 * Modern Card Component Styles
 */

.modern-card {
  background: white;
  border-radius: var(--radius-2xl);
  border: 1px solid var(--neutral-200);
  transition: all var(--transition-base);
  position: relative;
  overflow: hidden;
}

/* Variants */
.modern-card--default {
  background: white;
  border-color: var(--neutral-200);
}

.modern-card--elevated {
  background: white;
  border-color: var(--neutral-100);
  box-shadow: var(--shadow-lg);
}

.modern-card--outlined {
  background: transparent;
  border-color: var(--neutral-300);
  border-width: 2px;
}

.modern-card--filled {
  background: var(--neutral-50);
  border-color: var(--neutral-200);
}

.modern-card--gradient {
  background: linear-gradient(135deg, #FFF7ED 0%, #FFEAD5 100%);
  border-color: #FED7AA;
}

/* Padding Variants */
.modern-card--padding-sm {
  padding: var(--space-4);
}

.modern-card--padding-md {
  padding: var(--space-6);
}

.modern-card--padding-lg {
  padding: var(--space-8);
}

.modern-card--padding-xl {
  padding: var(--space-10);
}

/* Shadow Variants */
.modern-card--shadow-none {
  box-shadow: none;
}

.modern-card--shadow-sm {
  box-shadow: var(--shadow-sm);
}

.modern-card--shadow-md {
  box-shadow: var(--shadow-md);
}

.modern-card--shadow-lg {
  box-shadow: var(--shadow-lg);
}

.modern-card--shadow-xl {
  box-shadow: var(--shadow-xl);
}

/* Interactive States */
.modern-card--hover:hover {
  transform: translateY(-2px);
  box-shadow: var(--shadow-xl);
}

.modern-card--clickable {
  cursor: pointer;
  -webkit-user-select: none;
          user-select: none;
}

.modern-card--clickable:hover {
  transform: translateY(-2px);
  box-shadow: var(--shadow-xl);
  border-color: #FFEAD5;
}

.modern-card--clickable:active {
  transform: translateY(0);
  box-shadow: var(--shadow-md);
}

/* Card Header */
.modern-card__header {
  padding-bottom: var(--space-6);
  border-bottom: 1px solid var(--neutral-200);
  margin-bottom: var(--space-6);
}

.modern-card__title {
  font-size: var(--text-xl);
  font-weight: var(--font-weight-bold);
  color: var(--neutral-900);
  margin: 0 0 var(--space-2) 0;
}

.modern-card__subtitle {
  font-size: var(--text-sm);
  color: var(--neutral-600);
  margin: 0;
}

/* Card Body */
.modern-card__body {
  flex: 1 1;
}

/* Card Footer */
.modern-card__footer {
  padding-top: var(--space-6);
  border-top: 1px solid var(--neutral-200);
  margin-top: var(--space-6);
  display: flex;
  justify-content: flex-end;
  gap: var(--space-3);
}

/* Card Actions */
.modern-card__actions {
  display: flex;
  gap: var(--space-3);
  align-items: center;
}

/* Card Content */
.modern-card__content {
  display: flex;
  flex-direction: column;
  gap: var(--space-4);
}

/* Card Grid */
.modern-card__grid {
  display: grid;
  gap: var(--space-4);
}

.modern-card__grid--2 {
  grid-template-columns: repeat(2, 1fr);
}

.modern-card__grid--3 {
  grid-template-columns: repeat(3, 1fr);
}

.modern-card__grid--4 {
  grid-template-columns: repeat(4, 1fr);
}

/* Responsive Design */
@media (max-width: 768px) {
  .modern-card--padding-lg {
    padding: var(--space-6);
  }

  .modern-card--padding-xl {
    padding: var(--space-8);
  }

  .modern-card__grid--2,
  .modern-card__grid--3,
  .modern-card__grid--4 {
    grid-template-columns: 1fr;
  }
}

/* Animation */
.modern-card {
  animation: fadeInUp 0.4s ease-out;
}

/* Focus States */
.modern-card--clickable:focus {
  outline: 2px solid var(--primary-600);
  outline-offset: 2px;
}

/* Dark Mode Support */
@media (prefers-color-scheme: dark) {
  .modern-card--default {
    background: var(--neutral-800);
    border-color: var(--neutral-700);
  }

  .modern-card__title {
    color: var(--neutral-100);
  }

  .modern-card__subtitle {
    color: var(--neutral-400);
  }

  .modern-card__header,
  .modern-card__footer {
    border-color: var(--neutral-700);
  }
}`, "",{"version":3,"sources":["webpack://./src/components/common/ModernCard.css"],"names":[],"mappings":"AAAA;;EAEE;;AAEF;EACE,iBAAiB;EACjB,gCAAgC;EAChC,oCAAoC;EACpC,sCAAsC;EACtC,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA,aAAa;AACb;EACE,iBAAiB;EACjB,gCAAgC;AAClC;;AAEA;EACE,iBAAiB;EACjB,gCAAgC;EAChC,4BAA4B;AAC9B;;AAEA;EACE,uBAAuB;EACvB,gCAAgC;EAChC,iBAAiB;AACnB;;AAEA;EACE,6BAA6B;EAC7B,gCAAgC;AAClC;;AAEA;EACE,6DAA6D;EAC7D,qBAAqB;AACvB;;AAEA,qBAAqB;AACrB;EACE,uBAAuB;AACzB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,wBAAwB;AAC1B;;AAEA,oBAAoB;AACpB;EACE,gBAAgB;AAClB;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,4BAA4B;AAC9B;;AAEA,uBAAuB;AACvB;EACE,2BAA2B;EAC3B,4BAA4B;AAC9B;;AAEA;EACE,eAAe;EACf,yBAAiB;UAAjB,iBAAiB;AACnB;;AAEA;EACE,2BAA2B;EAC3B,4BAA4B;EAC5B,qBAAqB;AACvB;;AAEA;EACE,wBAAwB;EACxB,4BAA4B;AAC9B;;AAEA,gBAAgB;AAChB;EACE,8BAA8B;EAC9B,2CAA2C;EAC3C,6BAA6B;AAC/B;;AAEA;EACE,yBAAyB;EACzB,oCAAoC;EACpC,yBAAyB;EACzB,4BAA4B;AAC9B;;AAEA;EACE,yBAAyB;EACzB,yBAAyB;EACzB,SAAS;AACX;;AAEA,cAAc;AACd;EACE,SAAO;AACT;;AAEA,gBAAgB;AAChB;EACE,2BAA2B;EAC3B,wCAAwC;EACxC,0BAA0B;EAC1B,aAAa;EACb,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA,iBAAiB;AACjB;EACE,aAAa;EACb,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA,iBAAiB;AACjB;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;AACrB;;AAEA,cAAc;AACd;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,qCAAqC;AACvC;;AAEA;EACE,qCAAqC;AACvC;;AAEA;EACE,qCAAqC;AACvC;;AAEA,sBAAsB;AACtB;EACE;IACE,uBAAuB;EACzB;;EAEA;IACE,uBAAuB;EACzB;;EAEA;;;IAGE,0BAA0B;EAC5B;AACF;;AAEA,cAAc;AACd;EACE,iCAAiC;AACnC;;AAEA,iBAAiB;AACjB;EACE,qCAAqC;EACrC,mBAAmB;AACrB;;AAEA,sBAAsB;AACtB;EACE;IACE,8BAA8B;IAC9B,gCAAgC;EAClC;;EAEA;IACE,yBAAyB;EAC3B;;EAEA;IACE,yBAAyB;EAC3B;;EAEA;;IAEE,gCAAgC;EAClC;AACF","sourcesContent":["/**\n * Modern Card Component Styles\n */\n\n.modern-card {\n  background: white;\n  border-radius: var(--radius-2xl);\n  border: 1px solid var(--neutral-200);\n  transition: all var(--transition-base);\n  position: relative;\n  overflow: hidden;\n}\n\n/* Variants */\n.modern-card--default {\n  background: white;\n  border-color: var(--neutral-200);\n}\n\n.modern-card--elevated {\n  background: white;\n  border-color: var(--neutral-100);\n  box-shadow: var(--shadow-lg);\n}\n\n.modern-card--outlined {\n  background: transparent;\n  border-color: var(--neutral-300);\n  border-width: 2px;\n}\n\n.modern-card--filled {\n  background: var(--neutral-50);\n  border-color: var(--neutral-200);\n}\n\n.modern-card--gradient {\n  background: linear-gradient(135deg, #FFF7ED 0%, #FFEAD5 100%);\n  border-color: #FED7AA;\n}\n\n/* Padding Variants */\n.modern-card--padding-sm {\n  padding: var(--space-4);\n}\n\n.modern-card--padding-md {\n  padding: var(--space-6);\n}\n\n.modern-card--padding-lg {\n  padding: var(--space-8);\n}\n\n.modern-card--padding-xl {\n  padding: var(--space-10);\n}\n\n/* Shadow Variants */\n.modern-card--shadow-none {\n  box-shadow: none;\n}\n\n.modern-card--shadow-sm {\n  box-shadow: var(--shadow-sm);\n}\n\n.modern-card--shadow-md {\n  box-shadow: var(--shadow-md);\n}\n\n.modern-card--shadow-lg {\n  box-shadow: var(--shadow-lg);\n}\n\n.modern-card--shadow-xl {\n  box-shadow: var(--shadow-xl);\n}\n\n/* Interactive States */\n.modern-card--hover:hover {\n  transform: translateY(-2px);\n  box-shadow: var(--shadow-xl);\n}\n\n.modern-card--clickable {\n  cursor: pointer;\n  user-select: none;\n}\n\n.modern-card--clickable:hover {\n  transform: translateY(-2px);\n  box-shadow: var(--shadow-xl);\n  border-color: #FFEAD5;\n}\n\n.modern-card--clickable:active {\n  transform: translateY(0);\n  box-shadow: var(--shadow-md);\n}\n\n/* Card Header */\n.modern-card__header {\n  padding-bottom: var(--space-6);\n  border-bottom: 1px solid var(--neutral-200);\n  margin-bottom: var(--space-6);\n}\n\n.modern-card__title {\n  font-size: var(--text-xl);\n  font-weight: var(--font-weight-bold);\n  color: var(--neutral-900);\n  margin: 0 0 var(--space-2) 0;\n}\n\n.modern-card__subtitle {\n  font-size: var(--text-sm);\n  color: var(--neutral-600);\n  margin: 0;\n}\n\n/* Card Body */\n.modern-card__body {\n  flex: 1;\n}\n\n/* Card Footer */\n.modern-card__footer {\n  padding-top: var(--space-6);\n  border-top: 1px solid var(--neutral-200);\n  margin-top: var(--space-6);\n  display: flex;\n  justify-content: flex-end;\n  gap: var(--space-3);\n}\n\n/* Card Actions */\n.modern-card__actions {\n  display: flex;\n  gap: var(--space-3);\n  align-items: center;\n}\n\n/* Card Content */\n.modern-card__content {\n  display: flex;\n  flex-direction: column;\n  gap: var(--space-4);\n}\n\n/* Card Grid */\n.modern-card__grid {\n  display: grid;\n  gap: var(--space-4);\n}\n\n.modern-card__grid--2 {\n  grid-template-columns: repeat(2, 1fr);\n}\n\n.modern-card__grid--3 {\n  grid-template-columns: repeat(3, 1fr);\n}\n\n.modern-card__grid--4 {\n  grid-template-columns: repeat(4, 1fr);\n}\n\n/* Responsive Design */\n@media (max-width: 768px) {\n  .modern-card--padding-lg {\n    padding: var(--space-6);\n  }\n\n  .modern-card--padding-xl {\n    padding: var(--space-8);\n  }\n\n  .modern-card__grid--2,\n  .modern-card__grid--3,\n  .modern-card__grid--4 {\n    grid-template-columns: 1fr;\n  }\n}\n\n/* Animation */\n.modern-card {\n  animation: fadeInUp 0.4s ease-out;\n}\n\n/* Focus States */\n.modern-card--clickable:focus {\n  outline: 2px solid var(--primary-600);\n  outline-offset: 2px;\n}\n\n/* Dark Mode Support */\n@media (prefers-color-scheme: dark) {\n  .modern-card--default {\n    background: var(--neutral-800);\n    border-color: var(--neutral-700);\n  }\n\n  .modern-card__title {\n    color: var(--neutral-100);\n  }\n\n  .modern-card__subtitle {\n    color: var(--neutral-400);\n  }\n\n  .modern-card__header,\n  .modern-card__footer {\n    border-color: var(--neutral-700);\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
